var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticStyle:{"width":"60%","height":"400px"},attrs:{"zoom":14,"center":_vm.center}},_vm._l((_vm.locationMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"animation":_vm.ani,"position":m.position},on:{"click":function($event){_vm.center = m.position}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }